import { humanizeKey } from "../lib/format";

export function JsonView({ value, compact = false }: { value: unknown; compact?: boolean }) {
  if (value === null || value === undefined) return <span className="muted">—</span>;
  if (typeof value === "boolean") return <span>{value ? "Да" : "Нет"}</span>;
  if (typeof value === "string" || typeof value === "number") return <span>{String(value)}</span>;
  if (Array.isArray(value)) {
    if (value.length === 0) return <span className="muted">Пусто</span>;
    return (
      <ul className="json-list">
        {value.map((item, index) => <li key={index}><JsonView value={item} compact={compact} /></li>)}
      </ul>
    );
  }
  if (typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>);
    if (entries.length === 0) return <span className="muted">Нет данных</span>;
    if (compact) return <code className="json-inline">{JSON.stringify(value, null, 2)}</code>;
    return (
      <dl className="property-list">
        {entries.map(([key, item]) => (
          <div key={key} className="property-list__row">
            <dt>{humanizeKey(key)}</dt>
            <dd><JsonView value={item} compact={false} /></dd>
          </div>
        ))}
      </dl>
    );
  }
  return <span>{String(value)}</span>;
}
